import { isEmpty } from '@sgme/fp';
import classNames from 'classnames';
import styled from 'styled-components';

const StyledSpan = styled.span<{ $isShort: boolean }>`
  width: ${props => props.$isShort && '20px'};
  height: ${props => props.$isShort && '20px'};
`;

type QuoteLabelProps = {
  shortLabel: string;
  className?: string;
  color: 'primary' | 'danger';
  label?: string;
};

export function QuoteLabel({ shortLabel, className, color, label }: QuoteLabelProps) {
  return (
    <>
      <StyledSpan
        $isShort={isEmpty(label)}
        className={classNames(className, `align-middle   text-center  fs-14`, {
          'text-black': color === 'danger',
          'bg-danger': color === 'danger',
          'bg-opacity-70': color === 'danger',
          'bg-primary': color === 'primary',
          'rounded-circle d-block': isEmpty(label),
          'rounded-1 d-flex px-2': !isEmpty(label),
        })}
      >
        {isEmpty(label) ? shortLabel : label}
      </StyledSpan>
    </>
  );
}
